import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

// Layout components
import { Header } from './Header';
import { Footer } from './Footer';
import { Hero } from './homepage/Hero';
import { Hero2 } from './homepage/Hero2';

// Section components
import { IntegrationFeatures } from './homepage/IntegrationFeatures';
import { ApiFeatures } from './homepage/ApiFeatures';
import { CtaSection } from './homepage/CtaSection';

export function HomePage() {
  return (
    <div className="min-h-screen bg-gray-900 dark">
      <Header />

      {/* Hero Sections */}
      <div className="pt-16">
        <Hero2 />
      </div>

      {/* Integration Features */}
      <IntegrationFeatures />

      {/* Our Integrations Section */}
      <div className="bg-gray-50 py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl text-gray-900 mb-4">
              Our Integrations
            </h2>
            <p className="text-xl text-gray-600">
              Trusted by leading Property Management Systems worldwide
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 mb-12">
            {/* Opera Logo */}
            <div className="bg-white rounded-lg shadow-sm p-6 flex items-center justify-center hover:shadow-md transition-shadow">
              <img 
                src="/images/integrations/opera.png" 
                alt="Opera PMS" 
                className="h-12 object-contain"
              />
            </div>

            {/* Mews Logo */}
            <div className="bg-white rounded-lg shadow-sm p-6 flex items-center justify-center hover:shadow-md transition-shadow">
              <img 
                src="/images/integrations/mews.png" 
                alt="Mews" 
                className="h-12 object-contain"
              />
            </div>

            {/* StayNTouch Logo */}
            <div className="bg-white rounded-lg shadow-sm p-6 flex items-center justify-center hover:shadow-md transition-shadow">
              <img 
                src="/images/integrations/stayntouch.png" 
                alt="StayNTouch" 
                className="h-12 object-contain"
              />
            </div>

            {/* Apaleo Logo */}
            <div className="bg-white rounded-lg shadow-sm p-6 flex items-center justify-center hover:shadow-md transition-shadow">
              <img 
                src="/images/integrations/apaleo.svg" 
                alt="Apaleo" 
                className="h-12 object-contain"
              />
            </div>

            {/* Thais PMS Logo */}
            <div className="bg-white rounded-lg shadow-sm p-6 flex items-center justify-center hover:shadow-md transition-shadow">
              <img 
                src="/images/integrations/thais-pms.svg" 
                alt="Thais PMS" 
                className="h-12 object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      {/* API Features */}
      <ApiFeatures />

      {/* CTA Section */}
      <CtaSection />

      <Footer />
    </div>
  );
}